var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2215 19.1669C34.2215 27.7536 27.2526 34.7224 18.6659 34.7224C10.0792 34.7224 3.11035 27.7536 3.11035 19.1669C3.11035 10.5802 10.0792 3.61133 18.6659 3.61133C27.2526 3.61133 34.2215 10.5802 34.2215 19.1669Z",
    fill: "#FF9515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4365 24.1147L19.6143 21.2369C18.7743 20.7391 18.0898 19.5414 18.0898 18.5614V12.1836",
    fill: "#FF9515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4365 24.1147L19.6143 21.2369C18.7743 20.7391 18.0898 19.5414 18.0898 18.5614V12.1836",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.03c85e763d09deb207cb2d4fe1ff41b8.svg";
export { ForwardRef as ReactComponent };